import { useEffect, useRef, useState } from "react";
import { acdCodes } from "../../utils/acdCodes";
import moment from "moment";
import { actions, basis, dueProcess, extent, suffix } from "../../utils/withdrawalOptions";

import { useNavigate } from "react-router-dom";
import { buildAddWithdrawal, buildUpdateFcwdDriverInfo, buildUpdateWithdrawalDetails, buildWithdrawalDetails, defaultConvictions, defaultDriverData, defaultWithdrawals, errMessage, isDown, isNewUser, makeWithdrawalObjectForAdd, postJson, setDefaultDriverData, toYMD } from "../../utils/data";
import { countryOptions } from "../../utils/countryOptions";
import { useAuth } from "../../context/AuthContext";
import { formatDOB } from "../consts/dateMask";
import Loading from "../tabs/loading";
import ShowComments from "./showComments.js"

function UpdateWithdrawal() {

    const {source, email, token} = useAuth();
    const navigate = useNavigate();
    const [extentCode, setExtentCode] = useState("");
    const [acdCode, setAcdCode] = useState("");
    const [selectedAcd, setSelectedAcd] = useState(null);
    const [selectedDueProcess, setDueProcess] = useState("");
    const [indefPerm, setIndefPerm] = useState("");
    const [selectedBasis, setBasis] = useState("");
    const [action, setAction] = useState("");
    const [comments, setComments] = useState();
    const [stateNative, setStateNative] = useState("");
    const [locator, setLocator] = useState("");
    const [reinstatementDate, setReinstatementDate] = useState("");
    const [eligibilityDate, setEligibilityDate] = useState("");
    const [effectiveDate, setEffectiveDate] = useState("");
    const [postedDate, setPostedDate] = useState("");
    const [linkId, setLinkId] = useState("");
    const [userId, setUserId] = useState(email);
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState([]);
    const screenRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false);
    const [notes, setNotes] = useState();

    const userType = "DEFAULT"; // Replace with actual user state logic
    const dataSource = {DataSource: source, CAorMXDown: isDown, userId: email}

    useEffect(() => {
        const fetchData = async () => {
            console.log(defaultWithdrawals);
            postJson('/api/withdrawal/details', buildWithdrawalDetails({driver: defaultDriverData, withdrawalId: defaultWithdrawals[0], sourceOpts: dataSource}), null, token)
            .then(function(result){
                setAcdCode(result.Withdrawals.DRVLicAcdWithdrawalReasonCode)
                const found = acdCodes.find(a => a.code === result.Withdrawals.DRVLicAcdWithdrawalReasonCode);
                setSelectedAcd(found || null);
                setAction(result.Withdrawals.DriverLicenseWithdrawalType)
                setBasis(result.Withdrawals.DriverLicenseWithdrawalBasis)
                setDueProcess(result.Withdrawals.DLWithdrawalDueProcessStatus)
                setExtentCode(result.Withdrawals.DRVLicWithdrawalExtentIdDlc)
                setEffectiveDate(moment(result.Withdrawals.DriverLicenseWithdrawalEffectiveDate).format('YYYY-MM-DD'))
                setStateNative(result.Withdrawals.DRVLicWithdrawalReasonReference)
                setLocator(result.Withdrawals.DLWithdrawalJurisdictionReportId)
                setPostedDate(moment(result.Withdrawals.WithdrawalDatePosted).format('YYYY-MM-DD'))
                setLinkId(result.Withdrawals.DLWithdrawalIdConvictionLinksGroup)
                setNotes(result.Withdrawals.WithdrawalStatusNotes)
                if(moment(result.Withdrawals.DLWithdrawalReinstatementDate).isValid()){
                    setReinstatementDate(moment(result.Withdrawals.DLWithdrawalReinstatementDate).format('YYYY-MM-DD'))
                }
                if(moment(result.Withdrawals.DRVLicWithdrawalEligibilityDate).isValid()){
                    setEligibilityDate(moment(result.Withdrawals.DRVLicWithdrawalEligibilityDate).format('YYYY-MM-DD'))
                } else {
                    setIndefPerm(result.Withdrawals.DRVLicWithdrawalEligibilityDate.toLowerCase())
                }
                
            })
        }
        fetchData()}, []);

    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
            return;
        }
    }

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const form = e.target;
        window.scrollTo(0, 0);

        const today = new Date();
        const formattedDate = today.toLocaleDateString('en-US');
        const formatNotes  =  formattedDate + " " + email + " " + notes;


        if (form.checkValidity() === false) {
        e.stopPropagation(); // prevent submit if invalid
        setLoading(false);
        } else {
                console.log("Submit in progress", reinstatementDate, eligibilityDate, indefPerm)
                const withdrawal = {
                    DriverLicenseWithdrawalIdCode: defaultWithdrawals[0],
                    DriverLicenseWithdrawalBasis: selectedBasis,
                    DLWithdrawalDueProcessStatus: selectedDueProcess,
                    DRVLicWithdrawalEligibilityDate: indefPerm === '' ? eligibilityDate : indefPerm.toUpperCase(),
                    DLWithdrawalReinstatementDate: reinstatementDate,
                    DRVLicWithdrawalExtentIdDlc: extentCode,
                    WithdrawalStatusNotes: formatNotes
                }
                const build = buildUpdateWithdrawalDetails({driver:defaultDriverData, withdrawal: withdrawal, sourceOpts: dataSource})
                console.log("Have request for add Withdrawal", build);
                await postJson('/api/withdrawal/update', build, null, token)
                .then(function(response) {
                    console.log("Response sent")
                    if (response.Message === "Withdrawal details updated"){
                        navigate(-1);
                    } else {
                        setErr(response.Message)
                    }
                })
            }
        setLoading(false);
        setValidated(true); 
    }
  
      return (
          <>
              <div className="App">
                <div>{err}</div>
                <div ref={screenRef}></div>
                <div>{errMessage}</div>
                {loading &&
                        <Loading />}
                  <h1>Update Withdrawal</h1>
                  <div id="table">
                      <form className={`needs-validation ${validated ? "was-validated" : ""}`} id="Index-form" noValidate onSubmit={handleSubmit}>
                          <div className="row">
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver State</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverState} disabled />
                              </div>
                              <div className="col-md-5">
                                  <label className="form-label"><b>Driver License</b></label>
                                  <input className="form-control" type="text"
                                  value={defaultDriverData.driverLicense} disabled />
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Effective Date </b></label>
                                  <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='effectiveDate' 
                                      onKeyDown={(e) => disableKey(e)}
                                      max={moment().format("YYYYMMDD")}
                                      value={effectiveDate}
                                       disabled />
                                    <div className="invalid-feedback">Please enter an Effective Date</div>
                              </div>
                              {indefPerm !== null && indefPerm === "" ? 
                                <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Eligible Date</b></label>
                                  <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='eligibilityDate' 
                                      onKeyDown={(e) => disableKey(e)}
                                      max={moment().format("YYYYMMDD")}
                                      value={eligibilityDate}
                                      onChange={(e) => setEligibilityDate(e.target.value)}
                                       required disabled/>
                                      <div className="invalid-feedback">Please enter an Eligible Date</div>
                              </div> :
                              <div className="col-md-3">
                                  <label className="form-label"><b>Withdrawal Eligible Date</b></label>
                                  <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='eligibilityDate'
                                      onKeyDown={(e) => disableKey(e)}
                                      value=""                               
                                      max={moment().format("YYYYMMDD")}
                                      disabled />
                                </div>}
                              
                              <div className="col-md-3">
                                  <label className="form-label"><b>Indef/Perm</b></label>
                                  <select className="form-select"
                                      value={indefPerm}
                                      onChange={(e) => setIndefPerm(e.target.value)}
                                      disabled
                                  >
                                      <option value="">-- INDEF/PERM --</option>
                                      <option value="indef">INDEF</option>
                                      <option value="perm">PERM</option>
                                  </select>
                              </div>
                          </div>
  
                          <div className="row">
                            <div className="col-md-3">
                                  <label className="form-label"><b>Withdrawal Reinstated Date</b></label>
                                  <input type="date" className="form-control" 
                                      placeholder="MM/DD/YYYY" 
                                      name='DLWithdrawalReinstatementDate' 
                                      value={reinstatementDate}
                                      onKeyDown={(e) => disableKey(e)}
                                      onChange={(e) => setReinstatementDate(e.target.value)}
                                      max={moment().format("YYYYMMDD")}/>
                              </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Action</b></label>
                                  <select className="form-select"
                                      value={action}
                                       disabled >
                                        <option value="" disabled>-- Action --</option>
                                      {actions[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Action</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Basis</b></label>
                                  <select className="form-select"
                                      value={selectedBasis}
                                      onChange={(e) => setBasis(e.target.value)}
                                       required
                                       disabled
                                  >
                                      <option value="" disabled>-- Basis --</option>
                                      {basis[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Basis</div>
                              </div>
                          </div>
                          <div className="row">
                            <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Due Process</b></label>
                                  <select className="form-select"
                                      value={selectedDueProcess}
                                      onChange={(e) => setDueProcess(e.target.value)}
                                       required
                                  >
                                      <option value="" disabled>-- Due Process --</option>
                                      {dueProcess[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select a Due Process</div>
                              </div>
                              
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> ACD Code</b></label>
                                    <select className="form-select"
                                        value={acdCode}
                                         disabled
                                    >
                                        <option value="" disabled>-- ACD Code --</option>
                                        {acdCodes.map((opt) => (
                                            <option key={opt.code} value={opt.code} title={opt.label}>
                                                {opt.code} - {opt.simple}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback">Please select an ACD Code</div>
                                </div>
                              <div className="col-md-3">
                                  <label className="form-label"><b><span className="text-danger">*</span> Extent Code</b></label>
                                  <select className="form-select"
                                      value={extentCode}
                                      onChange={(e) => setExtentCode(e.target.value)}
                                       required
                                       disabled
                                  >
                                      <option value="" disabled>-- Extent Code --</option>
                                      {extent[userType].map((opt) => (
                                          <option key={opt.code} value={opt.code}>
                                              {opt.label}
                                          </option>
                                      ))}
                                  </select>
                                  <div className="invalid-feedback">Please select an Extent Code</div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> Withdrawal Locator Number</b></label>
                                  <input type="text" className="form-control" name="locator" 
                                  value={locator}
                                  maxLength={18}  disabled />
                                  <div className="invalid-feedback">Please enter a Withdrawal Locator Number</div>
                              </div>
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> State Native Code</b></label>
                                  <input type="text" className="form-control" name="stateNative"
                                  value={stateNative}
                                  maxLength={8}  disabled />
                                  <div className="invalid-feedback">Please enter a State Native Code</div>
                              </div>
                              <div className="col">
                                  <label className="form-label"><b><span className="text-danger">*</span> Comments</b></label>
                                  <input type="text" className="form-control"
                                  value={comments}
                                  onChange={(e) => setNotes(e.target.value)}
                                  name="comments" maxLength={500}  required />
                                <a 
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    style={{ color: '#0070f3', textDecoration: 'underline', cursor: 'pointer' }}
                                >Past Comments</a>
                                         {isHovered && <ShowComments  comments={notes} />} 
                              </div>      
                                <div className="invalid-feedback">Please provide comments for the audit file.</div>
                                              
                          </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <label className="form-label"><b>Withdrawal Posted Date</b></label>
                                    <input type="date" className="form-control" 
                                        placeholder="MM/DD/YYYY" 
                                        name='postedDate'            
                                        value={postedDate}
                                        disabled />
                                </div>
                                <div className="col">
                                    <label className="form-label"><b>User ID</b></label>
                                    <input type="text" className="form-control"
                                    value={userId}
                                    name="userId" disabled />
                                </div>
                                <div className="col">
                                    <label className="form-label"><b>Link ID</b></label>
                                    <input type="text" className="form-control"
                                    value={linkId}
                                    name="linkId" disabled />
                                </div>
                            </div>
  
                          <button type="submit" className="btn btn-primary mt-3">
                            Update Withdrawal
                          </button>
                          <button type="button" onClick={(e) => handleCancel(e)} 
                          className="btn btn-secondary mt-3 ms-2">
                            Back to Details for DL:{defaultDriverData.driverLicense}
                          </button>
                      </form>
                  </div>
              </div>
  
              {/* Modal for ACD Info */}
              {selectedAcd && (
                  <div className="modal fade" id="acdInfoModal" tabIndex="-1" aria-labelledby="acdInfoModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                          <div className="modal-content">
                              <div className="modal-header">
                                  <h5 className="modal-title" id="acdInfoModalLabel">ACD Code Information</h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                              </div>
                              <div className="modal-body">
                                  <p><strong>ACD Code:</strong> {selectedAcd.code}</p>
                                  <p><strong>Description:</strong> {selectedAcd.label}</p>
                                  {selectedAcd.validation && (
                                      <p><strong>Validation:</strong> {selectedAcd.validation}</p>
                                  )}
                                  {selectedAcd.moreInfo && (
                                      <p><strong>More Info:</strong> {selectedAcd.moreInfo}</p>
                                  )}
                              </div>
                              <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                              </div>
                          </div>
                      </div>
                  </div>
              )}
          </>
      );
}

export default UpdateWithdrawal;